import { styled } from '@mui/material/styles'
type WizardFooterProps = {
  footerBottom?: string
}

export const WizardFooter = styled('div', {
  name: 'WizardFooter',
  slot: 'Root',
  skipSx: true,
  skipVariantsResolver: true,
  shouldForwardProp: (prop) => prop !== 'footerBottom',
})<WizardFooterProps>(({ theme, footerBottom }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  padding: theme.spacing(2),
  justifyContent: 'flex-end',
  borderTop: `1px solid ${theme.palette.divider}`,
  position: 'absolute',
  textAlign: 'right',
  width: '100%',
  bottom: footerBottom ? footerBottom : '77px',
  ' > button:not(:last-child)': {
    marginRight: theme.spacing(1),
  },
  overflow: 'hidden',
  backgroundColor: 'white',
  zIndex: 100,
}))
